import useSidebarState from '../../hooks/useSidebarState';
import { uiText, useUiLanguage } from '../../utils/uiTranslation';
import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Sidebar from '../Sidebar';
import useTeamAccessProfile from '../../hooks/useTeamAccessProfile';
import ManpowerRequestsPanel from './ManpowerRequestsPanel';
import './ManpowerRequest.css';

const ManpowerRequestsPage = () => {
  useUiLanguage();
    const [sidebarCollapsed, setSidebarCollapsed] = useSidebarState();
    const navigate = useNavigate();
    const location = useLocation();
    const teamAccess = useTeamAccessProfile();
    const canManageRequests = teamAccess.hasPermission('canPostJobs');
    const initialRequestId = location?.state?.manpowerFocusId || null;

    return (
        <div className="manpower-requests-page-shell">
            <Sidebar collapsed={sidebarCollapsed} onToggle={setSidebarCollapsed} />
            <main
                className="manpower-requests-page"
                style={{
                    marginInlineStart: sidebarCollapsed ? '60px' : '240px',
                    width: `calc(100vw - ${sidebarCollapsed ? '60px' : '240px'})`
                }}
            >
                <div className="manpower-requests-page-inner">
                    {teamAccess.loading ? (
                        <div className="manpower-page-state">
                            <i className="fa-solid fa-spinner fa-spin" />
                            <h2>{uiText("Loading manpower requests...")}</h2>
                        </div>
                    ) : !canManageRequests ? (
                        <div className="manpower-page-state">
                            <i className="fa-solid fa-lock" />
                            <h2>{uiText("Manpower Requests")}</h2>
                            <p>{uiText("You do not have permission to manage manpower requests.")}</p>
                        </div>
                    ) : (
                        <ManpowerRequestsPanel
                            companyUID={teamAccess.companyUID}
                            initialRequestId={initialRequestId}
                            canManageRequests={canManageRequests}
                            variant="page"
                            onCreateJobPost={(request) => {
                                navigate('/', {
                                    state: {
                                        openPostJob: true,
                                        sourceManpowerRequest: request
                                    }
                                });
                            }}
                        />
                    )}
                </div>
            </main>
        </div>
    );
};

export default ManpowerRequestsPage;
